import {
  Agent,
  ATLAS_KB_AGENT_WITH_DEEP_RESEARCH,
} from "@amzn/atlas-chat-react-library";

/** Matches the `minerva_kb_agent` key in AtlasChatService's gaia_dev config. */
export const MINERVA_KB_AGENT: Agent = {
  id: "minerva_kb_agent",
  name: "Minerva Agent",
  supportsDeepResearch: false,
};

/**
 * The agents offered on a team's chat surface, shared by the full page and the
 * sidebar so both read one list.
 *
 * Move agent configuration to backend API call or global config instead of
 * hardcoding team names. For the gaia_dev and emea_stores teams, Minerva is
 * offered (and pre-selected) when the MINERVA_KB feature flag is on; otherwise
 * they fall back to Atlas (deep research). All other teams get no agent picker.
 */
export const agentsForTeam = (
  teamName: string,
  isMinervaKbEnabled: boolean,
): Agent[] => {
  if (teamName !== "gaia_dev" && teamName !== "emea_stores") {
    return [];
  }
  return isMinervaKbEnabled
    ? [MINERVA_KB_AGENT]
    : [ATLAS_KB_AGENT_WITH_DEEP_RESEARCH];
};
